const personalLinks = {
  mail: "rukiyeiremsarisoy@gmail.com",
  github: "https://github.com/rukitech",
  linkedin: "https://www.linkedin.com/in/rukiyeiremsarisoy/",
  instagram: "https://www.instagram.com/rukiblog/",
};

export default personalLinks;
